export default __webpack_public_path__ + "static/media/recycle.a7de752f.png";